import dayjs from "dayjs";
import camelcaseKeys from "src/utils/camelCaseKeys";
import adaptObservationQuestions from "../adaptObservationQuestions/adaptObservationQuestions";

const adaptObservationForm = (data: IObservationForm) => {
	const { observation_questions } = data;

	const publishedForm: PublishedForm = {
		...camelcaseKeys(data),
		observationQuestions: adaptObservationQuestions(observation_questions),
		updatedBy:
			typeof data.updated_by === "object" && data.updated_by !== null
				? data.updated_by.name
				: (data.updated_by ?? null),
		createdAt: dayjs(data.created_at).format("DD/MMM/YYYY"),
		updatedAt: dayjs(data.updated_at).format("DD/MMM/YYYY")
	};

	return publishedForm;
};

export default adaptObservationForm;
